<div *nzModalTitle></div>
<div class="modal-content flex flex-col items-center justify-center">
  @if (isLoading()) {
    <korviu-loader />
  }
  <i nz-icon class="mb-4 md:mb-6" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <path
        d="M25.5 33.9999C26.0667 33.9999 26.5417 33.8082 26.925 33.4249C27.3083 33.0415 27.5 32.5665 27.5 31.9999C27.5 31.4332 27.3083 30.9582 26.925 30.5749C26.5417 30.1915 26.0667 29.9999 25.5 29.9999C24.9333 29.9999 24.4583 30.1915 24.075 30.5749C23.6917 30.9582 23.5 31.4332 23.5 31.9999C23.5 32.5665 23.6917 33.0415 24.075 33.4249C24.4583 33.8082 24.9333 33.9999 25.5 33.9999ZM23.5 25.9999H27.5V13.9999H23.5V25.9999ZM25.5 43.9999C22.7333 43.9999 20.1333 43.4749 17.7 42.4249C15.2667 41.3749 13.15 39.9499 11.35 38.1499C9.55 36.3499 8.125 34.2332 7.075 31.7999C6.025 29.3665 5.5 26.7665 5.5 23.9999C5.5 21.2332 6.025 18.6332 7.075 16.1999C8.125 13.7665 9.55 11.6499 11.35 9.84988C13.15 8.04988 15.2667 6.62488 17.7 5.57488C20.1333 4.52488 22.7333 3.99988 25.5 3.99988C28.2667 3.99988 30.8667 4.52488 33.3 5.57488C35.7333 6.62488 37.85 8.04988 39.65 9.84988C41.45 11.6499 42.875 13.7665 43.925 16.1999C44.975 18.6332 45.5 21.2332 45.5 23.9999C45.5 26.7665 44.975 29.3665 43.925 31.7999C42.875 34.2332 41.45 36.3499 39.65 38.1499C37.85 39.9499 35.7333 41.3749 33.3 42.4249C30.8667 43.4749 28.2667 43.9999 25.5 43.9999Z"
        fill="#F28334"
      />
    </svg>
  </i>
  <span class="paragraph-large outfit mb-4 font-bold md:mb-6">
    {{ 'buildYourNetwork.removeReferrals' | translate }}
  </span>
  <p class="paragraph-medium modal-body m-0 text-center font-light outfit">
    {{ confirmationKey | translate: { count: selectedCount } }}
  </p>
</div>
<div *nzModalFooter class="flex gap-4">
  <korviu-button class="w-full" color="ghost" [disabled]="isLoading()" (onclick)="onCancelClick()">
    {{ 'common.back' | translate }}
  </korviu-button>
  <korviu-button class="w-full" color="tertiary" [loading]="isLoading()" (onclick)="onRemoveClick()">
    {{ 'common.continue' | translate }}
  </korviu-button>
</div>
